import styled from 'styled-components';

const FieldRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
  & > :not(:last-child) {
    margin-right: 10px;
  }
`;

export default FieldRow;



// WEBPACK FOOTER //
// ./components/layout/FieldRow.js